<template>
  <ZubieDialog
    ref="dialog"
    action-button-data-t="editAssetAdd"
    :action-button-text="saveButtonText"
    cancel-button-data-t="editAssetCancel"
    :content-style="`max-width: ${$q.screen.xs ? '100%;' : '400px'}`"
    :dirty="isDirty"
    :maximized="$q.screen.xs"
    :processing="saveInProgress"
    :title="`${assetKey ? 'Edit' : 'Add'} Asset`"
    @hide="onClose"
    @submit="onSubmit"
  >
    <AssetForm
      :asset="asset"
      :assetTypeError="assetTypeError"
      :saveInProgress="saveInProgress"
      @input="
        asset = { ...asset, ...$event };
        isDirty = true;
        error = null;
        assetTypeError = null;
      "
    />
    <q-banner v-if="error" class="q-mt-md text-white bg-negative">{{ error }}</q-banner>
  </ZubieDialog>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep';
import { mapActions, mapGetters, mapState } from 'vuex';
import AssetForm from 'components/assets/AssetForm';

export default {
  name: 'EditAssetDialog',
  props: {
    assetKey: String,
    visible: Boolean,
  },
  components: {
    AssetForm,
  },
  computed: {
    ...mapState('assets', ['assetTypes']),
    ...mapGetters('assets', ['assets']),
    hasErrors() {
      return Boolean(this.error || this.assetTypeError);
    },
    saveButtonText() {
      if (this.assetKey) {
        return this.saveInProgress ? 'Saving' : 'Save';
      }
      return this.saveInProgress ? 'Adding' : 'Add';
    },
    typeOptions() {
      return Object.values(this.assetTypes).map(({ key, name }) => ({
        label: name,
        value: key,
      }));
    },
  },
  data() {
    return {
      asset: {},
      assetTypeError: null,
      error: null,
      isDirty: false,
      isLoading: false,
      saveInProgress: false,
    };
  },
  methods: {
    ...mapActions('assets', ['saveAsset']),
    hide() {
      this.$refs.dialog.hide();
    },
    onClose() {
      this.asset = null;
      this.error = null;
      this.$emit('hide');
    },
    async onSubmit() {
      this.error = null;
      this.saveInProgress = true;

      // Show error if asset is being created without having an asset type
      if (!this.asset.assetTypeKey && Object.keys(this.assetTypes).length === 0) {
        this.assetTypeError = new Error('Please create an asset type.');
      }

      // Handle creation of new asset
      let response;
      if (!this.hasErrors) {
        response = await this.saveAsset(this.asset);
        if (response.error) {
          this.error = response.error;
        }
      }

      this.saveInProgress = false;

      if (!this.hasErrors) {
        this.hide();
        this.$q.notify({
          color: 'positive',
          icon: 'check_circle',
          message: `Successfully ${this.assetKey ? 'updated' : 'created new asset'}: ${response.nickname}`,
        });
      }
    },
    show() {
      this.$refs.dialog.show();
    },
  },
  async mounted() {
    this.isLoading = true;

    if (this.assetKey) {
      this.asset = _cloneDeep(this.assets.find(({ key }) => key === this.assetKey));
    }

    this.isLoading = false;
  },
};
</script>
